// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2MU_u","productName":"Table_productName__nz51_"};